"use client";
import React, { useCallback, useState, useRef } from "react";
import PropTypes from "prop-types";
import HighlighterListingProjectCard from "components/homepage/highlighter-card/project-card";

import styles from "./styles.module.css";
import Pagination from "components/pagination-inside";
import { getCompanyDetailForClient } from "@/src/services/companyDetail";

const Projects = ({ data }) => {
  const companySlug = data?.detailData?.[0]?.company?.slug;
  const titleRef = useRef();
  const [projectsToBeShown, setProjectsToBeShown] = useState(data);
  const [isLoading, setIsLoading] = useState(false);

  const scrollToTitle = useCallback(() => {
    if (titleRef.current) {
      const elementTopPosition = titleRef?.current?.getBoundingClientRect()?.top;
      window.scrollTo({
        top: window.scrollY + elementTopPosition - 30,
        behavior: "smooth",
      });
    }
  }, []);

  const getProjects = async (page) => {
    setIsLoading(true);
    const response = await getCompanyDetailForClient(companySlug, page + 1);
    if (response) {
      const data = {
        detailData: response?.projectCards?.records,
        total: response?.projectCards?.total,
      };
      setProjectsToBeShown(data);
    }
    setIsLoading(false);
  };

  const handlePageChange = (page) => {
    getProjects(page);
    scrollToTitle();
  };
  return (
    <>
      {isLoading && (
        <div className={styles.loading}>
          <div className={styles.loadingSpinner} />
        </div>
      )}
      <div className={styles.wrapper}>
        <h2 className={styles.title} ref={titleRef}>
          Projeler
        </h2>
        <div className={styles.projectCardWrapper}>
          {projectsToBeShown?.detailData?.map((item, index) => (
            <HighlighterListingProjectCard key={index} listItemInfo={item} isCompanyDetail />
          ))}
        </div>
        {projectsToBeShown?.total > 9 && (
          <div className={styles.paginationWrapper}>
            <Pagination totalItems={projectsToBeShown?.total} itemsPerPage={9} onPageChange={handlePageChange} />
          </div>
        )}
      </div>
    </>
  );
};

Projects.propTypes = {
  data: PropTypes.object,
};
export default Projects;
